const B = "https://static.prod-images.emergentagent.com/jobs/bbc6683c-3657-4952-83c5-84bca239fef7/images";

export const IMAGES = {
  heroArrival: {
    src: `${B}/f018ba64a696c205b9fe72d673127a45048f81650ac044aa1050e0dbf085a4a4.jpeg`,
    alt: "Firemní tým vystupuje z dodávky na horské silnici, v mlze v pozadí silueta Ještědu",
    w: 1264, h: 848,
  },
  envelope: {
    src: `${B}/cadc39b6fb419fbd61df421f14b2230677b5e83a2eaadee2d2ba6024427ccd49.jpeg`,
    alt: "Ruce otevírají papírovou obálku s prvními instrukcemi mise na dřevěném stole",
    w: 1024, h: 1024,
  },
  mapTable: {
    src: `${B}/c6f511a8729652a0dbb6b79d5e0f63e7da912b168d588ed58c132ebf25feb5b2.jpeg`,
    alt: "Turistická mapa s vyznačenou trasou, buzolou a lampou na stole ve Warehouse Liberec",
    w: 1024, h: 1024,
  },
  forestMission: {
    src: `${B}/6b98a0c506facfc65b037a0ea45056988e63e26a3eaba1518205e0e7e09ec8ec.jpeg`,
    alt: "Tým s mapou postupuje mlžným smrkovým lesem během Mission Ještěd",
    w: 1264, h: 848,
  },
  qrCheckpoint: {
    src: `${B}/3f32103591d06d3924501e573e0cf4d14197d0794a395245e1f446ecf7e2af46.jpeg`,
    alt: "Účastník skenuje QR kód checkpointu na dřevěném sloupku v lese",
    w: 1024, h: 1024,
  },
  summit: {
    src: `${B}/d7a95e112f954d81f6c7242f8c9a22a66fae954f5606d856e5ee3dde06643990.jpeg`,
    alt: "Tým slaví finish na vrcholu Ještědu pod vysílačem při západu slunce",
    w: 1264, h: 848,
  },
  finishDrink: {
    src: `${B}/4752e5b517f6e39938a49eb0c9d700ac2ee6712beef77e01b5ecd14a0b6631e5.jpeg`,
    alt: "Tým si přiťukává finish drinkem na vyhlídce při západu slunce",
    w: 1024, h: 1024,
  },
  warehouseExterior: {
    src: `${B}/a1040aebbaa99be0a731381377e2c2116d73a04a508a8ea18e401db79cf3e4ab.jpeg`,
    alt: "Večerní exteriér industriálního Warehouse Liberec s rozsvícenými okny",
    w: 1264, h: 848,
  },
  warehouseParty: {
    src: `${B}/99126c2de14abc67c8309d1b2f0908917e163583f21e1a1154761b1a301fe2fb.jpeg`,
    alt: "Soukromá firemní party ve Warehouse Liberec, DJ za pultem a tančící tým",
    w: 1264, h: 848,
  },
  dinner: {
    src: `${B}/0fe120de6eb9b5841591043a64e41ab10307491fea8551f13f030ac78756e05d.jpeg`,
    alt: "Společná večeře u dlouhého stolu v industriálním prostoru Warehouse",
    w: 1264, h: 848,
  },
};

export const GALLERY_STRIP = [
  IMAGES.heroArrival,
  IMAGES.envelope,
  IMAGES.mapTable,
  IMAGES.forestMission,
  IMAGES.qrCheckpoint,
  IMAGES.summit,
  IMAGES.finishDrink,
  IMAGES.warehouseExterior,
  IMAGES.warehouseParty,
];
